// extracted by mini-css-extract-plugin
export default {"modal":"AddStudentModal_modal__1zn1f","SudentName":"AddStudentModal_SudentName__c-ai2","submit":"AddStudentModal_submit__PigPl","StudentName":"AddStudentModal_StudentName__tMy-a"};